/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsDeclarationApplyDetailsResponseDto>
>;
export function request(
  params: API.tms.customsDeclarationApplyDetails.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationApplyDetails/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
